module.exports = __webpack_public_path__ + "img/00728b5.png";